// actionTypes.ts
import { API_TYPE } from "../../utils/config";
export const SET_LANGUAGE_VAR = "SET_LANGUAGE_VAR";
export const GET_LANGUAGES_LIST = API_TYPE("GET_LANGUAGES_LIST");
export const SET_AGENT_LANGUAGE = API_TYPE("SET_AGENT_LANGUAGE");
export const GET_IPINFO_ACTIONTYPE = API_TYPE("GET_IPINFO_ACTIONTYPE");
